type TextTransform = 'none' | 'capitalize' | 'uppercase' | 'lowercase'
// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h6Str: true
    h7Str: true
    h7: true
    subtitle: true
    bodyLargeStr: true
    bodyLarge: true
    bodySmallStr: true
    bodySmall: true
    caption: true
    overline: true
    buttonLG: true
    buttonXSM: true
    buttonSM: true

    // TO-DO: remove all variants below and use the ones above instead, after updating all usages
    caption1: true
    caption3: true
    body3: true
    body4: true
    // h4Str: true;
  }
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    h6Str: React.CSSProperties
    h7Str: React.CSSProperties
    h7: React.CSSProperties
    subtitle: React.CSSProperties
    bodyLargeStr: React.CSSProperties
    bodyLarge: React.CSSProperties
    bodySmallStr: React.CSSProperties
    bodySmall: React.CSSProperties
    caption: React.CSSProperties
    overline: React.CSSProperties
    buttonLG: React.CSSProperties
    buttonSM: React.CSSProperties
    buttonXSM: React.CSSProperties
    // TO-DO: remove all variants below and use the ones above instead, after updating all usages
    caption1: React.CSSProperties
    caption3: React.CSSProperties
    // h4Str: React.CSSProperties;
    body3: React.CSSProperties
    body4: React.CSSProperties
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    h6Str: React.CSSProperties
    h7Str: React.CSSProperties
    h7: React.CSSProperties
    subtitle: React.CSSProperties
    bodyLargeStr: React.CSSProperties
    bodyLarge: React.CSSProperties
    bodySmallStr: React.CSSProperties
    bodySmall: React.CSSProperties
    caption: React.CSSProperties
    buttonLG: React.CSSProperties
    buttonSM: React.CSSProperties
    buttonXSM: React.CSSProperties
    overline?: React.CSSProperties
    // TO-DO: remove all variants below and use the ones above instead, after updating all usages
    caption1?: React.CSSProperties
    // h4Str?: React.CSSProperties;
    body3?: React.CSSProperties
    body4?: React.CSSProperties
  }
}

export default {
  fontFamily: 'Geomanist',
  fontWeightLight: 100,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  fontWeightBlack: 700,
  h1: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '6rem', // 96px
  },
  h2: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '3.75rem', // 60px
  },
  h3: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '3rem', // 48px
  },
  h4: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '34px',
  },
  // h4Str: {
  //   fontWeight: 500,
  //   lineHeight: 1.5,
  //   fontSize: '2.125rem', // 34px
  // },
  h5: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '1.5rem', // 24px
  },
  h6: {
    fontWeight: 400,
    lineHeight: 1.3, // 28px
    fontSize: '1.25rem', // 20px
  },
  h6Str: {
    fontWeight: 500,
    lineHeight: 1.3,
    fontSize: '1.25rem', // 20px
  },
  h7: {
    fontWeight: 400,
    lineHeight: 1,
    fontSize: '1rem', // 16px
  },
  h7Str: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '1rem', // 16px
  },

  subtitle: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '0.875rem', // 14px
  },
  bodyLargeStr: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '1rem', // 16px
  },
  bodyLarge: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '1rem', // 16px
  },
  bodySmallStr: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '0.875rem', // 14px
  },
  bodySmall: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '0.875rem', // 14px
  },
  caption: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '0.75rem', // 12px
  },
  overline: {
    fontWeight: 400,
    lineHeight: 1.6,
    fontSize: '0.625rem', // 10px
    textTransform: 'none' as TextTransform,
  },
  buttonLG: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '0.875rem', // 14px
  },
  buttonSM: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '0.75rem', // 12px
  },
  buttonXSM: {
    fontWeight: 500,
    lineHeight: 1,
    fontSize: '0.625rem', // 10px
  },
  // TO-DO: remove all variants below and use the ones above instead, after updating all usages
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.3,
    fontSize: '0.875rem', // 14px
  },
  body1: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '1rem', // 16px
  },
  body2: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '1rem', // 16px
  },
  body3: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '0.875rem', // 14px
  },
  body4: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '0.875rem', // 14px
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 0.875,
    fontSize: '0.875rem', // 16px
  },
  caption1: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '0.750rem', // 12px
  },
  button: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '0.875rem', // 12px
  },
  caption3: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '0.5rem', // 8px
  },
}
